import React from 'react';
import PropTypes from 'prop-types';

import {Pill as BasePill} from 'views/components';

// A status pill with no menu and no click handler, so a click on it opens the card like anywhere else.
const Pill = (props) => {
  const {
    backgroundColor,
    borderColor,
    label,
    textColor,
  } = props;

  return (
    <BasePill
      backgroundColor={backgroundColor}
      borderColor={borderColor}
      label={label}
      sx={{
        minWidth: 0,
        gap: 0,
        borderRadius: '20px',
      }}
      textColor={textColor}
    />
  );
};

Pill.propTypes = {
  backgroundColor: PropTypes.string.isRequired,
  borderColor: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  textColor: PropTypes.string.isRequired,
};

export default Pill;
